import ImageProps from "./types";

const Image = ({ src, alt, ...args }: ImageProps) => (
  <img src={src} alt={alt} {...args} />
);

export default Image;
